import React from "react";

export function MetricsCard({ title, value, icon: Icon }) {
  return (
    <div className="card metrics-card h-100">
      <div className="card-body">
        <div className="d-flex align-items-center">
          <div className="metrics-icon p-3 me-3">
            <Icon size={24} className="icon" />
          </div>
          <div>
            <p className="metrics-title mb-1">{title}</p>
            <h4 className="metrics-value mb-0">
              {value}
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}